<template>
  <b-container>
    <transition name="slide-fade">
      <b-row class="h-100">
        <b-col
          class="d-flex flex-column justify-content-center login-wrapper--right-form"
        >
          <div class="d-flex">
            <a href="https://www.tradiepass.com.au/">
              <b-img src="/img/logo.svg" fluid />
            </a>
          </div>

          <div class="mt-4">
            <h3 class="font-weight-bold">Create an Account</h3>
            <p class="mt-3 grey--text">
              Sign up using your email below to securely store all your cards
              and important files.
            </p>
          </div>

          <b-form class="mt-3" @submit.prevent="onSignup">
            <b-row no-gutters>
              <b-col cols="12">
                <b-form-group id="input-group-1">
                  <label class="font-weight-bold">Email or Phone Number</label>
                  <b-form-input
                    id="input-1"
                    class="form-control effect-26"
                    :class="formCreds.email ? 'has-content' : ''"
                    required
                    @change="emailPhoneValues"
                    autofocus
                    placeholder="Enter email address or phone number"
                  ></b-form-input>
                  <div class="input-error" v-if="emailPhoneError">
                    {{ emailPhoneError }}
                  </div>
                </b-form-group>

                <b-form-group id="input-group-2">
                  <label class="font-weight-bold">Password</label>

                  <b-form-input
                    id="input-2"
                    v-model="formCreds.password"
                    class="form-control effect-26"
                    :class="formCreds.password ? 'has-content' : ''"
                    type="password"
                    autocomplete="new-password"
                    required
                    placeholder="Enter password"
                  ></b-form-input>
                  <div
                    class="input-error"
                    v-if="formCreds.$getError('password')"
                  >
                    {{ formCreds.$getError('password')[0] }}
                  </div>
                </b-form-group>

                <b-form-group id="input-group-3">
                  <label class="font-weight-bold">Confirm Password</label>

                  <b-form-input
                    id="input-3"
                    v-model="formCreds.password_confirmation"
                    class="form-control effect-26"
                    :class="
                      formCreds.password_confirmation ? 'has-content' : ''
                    "
                    type="password"
                    autocomplete="confirm-password"
                    required
                    placeholder="Confirm password"
                  ></b-form-input>
                  <div
                    class="input-error"
                    v-if="formCreds.$getError('password_confirmation')"
                  >
                    {{ formCreds.$getError('password_confirmation')[0] }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="12" lg="6" class="pr-lg-2">
                <b-button
                  :to="{ name: 'auth.login-page' }"
                  class="btn-outlined bg-white text-dark"
                  block
                  >Back</b-button
                >
              </b-col>

              <b-col cols="12" lg="6" class="pl-lg-2" block>
                <b-button class="pr-2" type="submit" variant="primary" block>
                  <b-spinner small v-if="formCreds.$busy" />
                  <span>Sign up</span>
                  <b-img
                    class="float-right"
                    src="/img/arrow-right.svg"
                    alt="arrow-right"
                    width="20"
                  />
                </b-button>
              </b-col>
            </b-row>

            <!-- <div class="ta-center mt-4">
              <label class="form-link-label">
                By signing up you agree to our
                <b-link class="form-link">terms of service</b-link>&nbsp;and
                that you have read our
                <b-link class="form-link">privacy policy</b-link>.
              </label>
            </div> -->
          </b-form>
        </b-col>
      </b-row>
    </transition>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import Form from '@/utils/form'
import IsEmail from 'isemail'

export default {
  data() {
    return {
      formCreds: new Form({
        email: '',
        phone_number: '',
        password: '',
        password_confirmation: ''
      }),
      emailOrPhone: ''
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    emailPhoneError() {
      if (this.formCreds.$getError('email')) {
        return this.formCreds.$getError('email')[0]
      } else if (
        this.formCreds.phone_number !== null &&
        this.formCreds.$getError('phone_number')
      ) {
        return this.formCreds.$getError('phone_number')[0]
      }
      return false
    }
  },

  methods: {
    emailPhoneValues(val) {
      let isEmail = IsEmail.validate(val)
      if (isEmail) {
        this.formCreds.phone_number = null
        this.formCreds.email = val
        this.emailOrPhone = 'email'
      } else {
        this.formCreds.phone_number = val
        this.formCreds.email = null
        this.emailOrPhone = 'phone'
      }
    },
    async onSignup(evt) {
      this.formCreds.$busy = true
      await this.$api
        .post('auth/register', this.formCreds.$data())
        .then(({ data }) => {
          this.formCreds.$busy = false
          this.$store.commit('auth/setToken', data.data)
          this.$store.commit('auth/setUser', data.data.user)
          this.$router.replace({
            name: 'auth.onboarding-page',
            params: { account: this.emailOrPhone }
          })
        })
        .catch(error => {
          this.formCreds.$handleError(error)
        })
    }
  },

  watch: {
    'form.email'() {
      this.form.$clearError('email')
    },
    'form.phone_number'() {
      this.form.$clearError('phone_number')
    },
    'form.password'() {
      this.form.$clearError('password')
    }
  }
}
</script>

<style lang="scss" scoped>
html,
body {
  height: 100%;
  margin: 0px;
}

.container {
  height: 100%;
}
</style>
